import { Link } from "react-router-dom";
import { Section, Overline } from "../components/Shared";
import { Seo } from "../components/Seo";
import { LEGAL_PAGES, LEGAL_META } from "../lib/legal";

export default function LegalPage({ slug }) {
  const page = LEGAL_PAGES[slug];
  const others = Object.values(LEGAL_PAGES).filter((p) => p.slug !== slug);
  return (
    <>
      <Seo page={`legal_${slug.replace(/-/g, "_")}`} breadcrumbs={[[page.title, `/${slug}`]]} />
      <Section className="pt-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <article className="lg:col-span-8 max-w-3xl" data-testid={`legal-page-${slug}`}>
            <Overline>Legal</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.1]">{page.title}</h1>
            <p className="mt-5 text-lg text-slate-700">{page.summary}</p>
            <p className="mt-2 text-sm text-slate-500 font-mono" data-testid="legal-updated">Last updated: {LEGAL_META.updated}</p>
            <div className="mt-10 space-y-8">
              {page.sections.map((s) => (
                <section key={s.h}>
                  <h2 className="text-xl font-bold text-slate-900">{s.h}</h2>
                  {s.p.map((para) => (
                    <p key={para.slice(0, 40)} className="mt-3 text-base text-slate-700 leading-relaxed">{para}</p>
                  ))}
                </section>
              ))}
            </div>
          </article>
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Other policies</div>
              <ul className="mt-4 space-y-2">
                {others.map((p) => (
                  <li key={p.slug}>
                    <Link to={`/${p.slug}`} data-testid={`legal-link-${p.slug}`} className="text-base font-medium text-cyan-700 hover:text-cyan-800">{p.title}</Link>
                  </li>
                ))}
              </ul>
              <p className="mt-6 text-sm text-slate-600">Questions about any policy? <Link to="/request-a-quote" className="text-cyan-700 font-medium">Contact us</Link>.</p>
            </div>
          </aside>
        </div>
      </Section>
    </>
  );
}
